import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import 'zone.js';

import {AppModule} from './app/app_module';

// Bootstrap the Angular app for the browser.
platformBrowserDynamic().bootstrapModule(AppModule);
